import { render, staticRenderFns } from "./HeaderUS.vue?vue&type=template&id=61dc9d4f&scoped=true&"
import script from "./HeaderUS.vue?vue&type=script&lang=js&"
export * from "./HeaderUS.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUS.vue?vue&type=style&index=0&id=61dc9d4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc9d4f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIPhoneNumber: require('/opt/build/repo/components/UI/PhoneNumber.vue').default,UIMenu: require('/opt/build/repo/components/UI/Menu.vue').default,CartBannerTop: require('/opt/build/repo/components/Cart/BannerTop.vue').default})
